module.exports = {
  formatTime: formatTime,
  fun
}  
//数据转化  
function formatNumber(n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

/** 
 * 时间戳转化为年 月 日 时 分 秒 
 * number: 传入时间戳 
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致 
*/
function formatTime(number, format) {

  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  var returnArr = [];

  var date = new Date(number * 1000);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}  
function fun(specificDate){
  let data = new Date(Date.parse(specificDate.replace('年', '-').replace('月', '-').replace('日', '')))
  let year = data.getFullYear();
  let month = data.getMonth() + 1;
  let date = data.getDate();
  return year + "-" + month + "-" + date
}


// WEBPACK FOOTER //
// ./src/utils/time.js